<div class="search-gourp-setting">
  <!-- 查询组名称 -->
  <div nz-row class="item">
    <div nz-col nzFlex="80px" class="label">查询组名称</div>
    <div nz-col nzFlex="1" class="content">
      <input nz-input placeholder="请输入查询组名称" [(ngModel)]="searchParams.name" />
    </div>
  </div>
  <div class="title">查询条件</div>
  <!-- 查询条件 -->
  <div nz-row class="item">
    <div nz-col nzFlex="80px" class="label">报告状态</div>
    <div nz-col nzFlex="1" class="content">
      <label *ngFor="let option of examinationStatuses" [(ngModel)]="option.checked" nz-checkbox (click)="onCheckboxChange($event, option, 'examinationStatuses')">
        {{ option.label }}
      </label>
    </div>
  </div>
  <div nz-row class="item">
    <div nz-col nzFlex="80px" class="label">检查类型</div>
    <div nz-col nzFlex="1" class="content">
      <label *ngFor="let option of examinationTypes" [(ngModel)]="option.checked" nz-checkbox (click)="onCheckboxChange($event, option, 'examinationTypes')">
        {{ option.label }}
      </label>
    </div>
  </div>
  <!-- 来源医院 -->
  <div nz-row class="item">
    <div nz-col nzFlex="80px" class="label">来源医院</div>
    <div nz-col nzFlex="1" class="content">
      <!-- select -->
      <nz-select nzMode="multiple" nzPlaceHolder="请选择来源医院" [(ngModel)]="searchParams.predicates.sourceHospitalIdList" nzShowSearch nzAllowClear style="min-width: 200px">
        <nz-option *ngFor="let option of sourceHospitalIdList" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
      </nz-select>
    </div>
  </div>
  <!-- 医生 -->
  <div nz-row class="item">
    <div nz-col nzFlex="80px" class="label">医生</div>
    <div nz-col nzFlex="1" class="content">
      <nz-select nzMode="multiple" nzPlaceHolder="请选择医生" [(ngModel)]="searchParams.predicates.doctors" nzShowSearch nzAllowClear style="min-width: 200px">
        <nz-option *ngFor="let option of doctors" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
      </nz-select>
    </div>
  </div>
  <!-- 设备类型 -->
  <!-- <div nz-row class="item">
    <div nz-col nzFlex="80px" class="label">设备类型</div>
    <div nz-col nzFlex="1" class="content">
      <nz-select nzMode="multiple" nzPlaceHolder="请选择设备类型" [(ngModel)]="searchParams.predicates.deviceTypes" nzShowSearch nzAllowClear style="min-width: 200px">
        <nz-option *ngFor="let option of deviceTypes" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
      </nz-select>
    </div>
  </div> -->
</div>
